import script from "./SenhaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SenhaModal.vue?vue&type=script&setup=true&lang=js"

import "./SenhaModal.vue?vue&type=style&index=0&id=033a5559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033a5559"]])

export default __exports__